import { Component,OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { Device } from '@ionic-native/device';
import { Storage } from '@ionic/storage';
import { AlertController } from 'ionic-angular';
import {ReferFriendsPage} from '../referfriends/referfriends';
import {KiloMenuPage} from "../kilomenu/kilomenu";
import {KiloPartyPage} from "../kiloparty/kiloparty";
import {KiloStorePage} from "../kilostore/kilostore";
@Component({
	selector: 'page-kilopoints',
	templateUrl: 'kilopoints.html',
	providers:[MydataService,MyUrlService,JsonData,Device]
})
export class KiloPointsPage implements OnInit {
	jsonDt : Array<JsonData>;
	kilopointDt:Array<JsonData>
	public allContacts: any
	ssss:Array<JsonData>;
	referFriendPoint:any;
	signupPoint:any;
	takeawayDiscount:any;
	description:any;
	descriptiones:any;
	descriptions:any;
	constructor(public alerCtrl: AlertController,public device: Device,private http:Http,public navCtrl: NavController,private mydataService: MydataService,private myurlService: MyUrlService) {
	

	}
	
	
	ngOnInit(){
		
		
		this.description=window.localStorage.getItem('description_kilomenus');
		//alert(this.description);
		this.descriptiones=window.localStorage.getItem('description_kilopartys');
		//alert(this.descriptiones);
		this.descriptions=window.localStorage.getItem('description_kilostores');
		//alert(this.descriptions);
		
		 this.referFriendPoint= window.localStorage.getItem('referFriendPoints');
		this.signupPoint= window.localStorage.getItem('signupPoints');
		this. takeawayDiscount= window.localStorage.getItem('takeawayDiscounts');
		//alert("referFriendPoint"+this.referFriendPoint);
		//alert("signupPoint"+this.signupPoint);
		//alert("takeawayDiscount"+this.takeawayDiscount);
		//  var ddd = window.localStorage.getItem('multiple');
			////console.log("sddfdfdgdfgfdgfddf====>"+ddd);
			//this. ssss=JSON.parse(ddd);
			////console.log("dsfssadsdfdsfsd==========>"+this.ssss);
			
		var userid= window.localStorage.getItem('userid');
		//alert(userid);
		this. homeservice();
		var kiloSabjiJSONdata = JSON.stringify({"userid":userid});
		//console.log("Product Url--->"+this.myurlService.KILOPOINT+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);		
		this.mydataService.postJSON(this.myurlService.KILOPOINT ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => console.log(''),() =>this.kilopointService());
	}
	
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
		}
	kilopointService=function(){
		this.kilopointDt = this.jsonDt.kilopoints;
		//console.log("kilopoint receive jsondata ==>"+JSON.stringify(this.jsonDt.kilopoints));
	}	
	
	homeservice=function(){
		var userid= window.localStorage.getItem('userid');
		//alert(userid)
		var kiloSabjiJSONdata = JSON.stringify({"userid":userid});
		
		//console.log("Home Url--->"+this.myurlService.HOMEURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
        this.mydataService.postJSON(this.myurlService.HOMEURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => console.log(''),() =>this.homeService());
	}
	
	homeService=function(){
		this.kilopointdataDt = this.jsonDt.kilopointdata;
		this.balances = this.kilopointdataDt[0].balance;
		////console.log("sfggf====="+this.balances);
		// window.localStorage.setItem('balance',this.balances);
	}
	
	goReferFriend(){
	this.navCtrl.push(ReferFriendsPage);
		//alert("refer Friend");
	}
	showTC(){
	 this.payTmErrorAlert("<ul><b><u>Kilo Points Rules</u></b></ul><ul><li>All customers who sign up through our Mobile App / Website will be referred as Kilo Loyale.</li><li>"+this.signupPoint +" Kilo points will be awarded on sign up through Mobile app. These points can be used immediately upon sign up.</li><li>Every Kilo Loyale will get a referral code. When he refers the app to his phone book contacts and the contact signs up using this code, then the referring Kilo Loyale will get"+this.referFriendPoint+"referral points.</li><li>The referral points can be used immediately after credit.</li><li>Kilo Points accumulated by a Kilo Loyale on his purchase will become active after 2 Hrs, for usage as discount.</li><li>Kilo points are valid for three calendar months after the month in which they are accumulated.</li><li>Kilo points can be redeemed towards discounts on every purchase subject to a limit prescribed as under (All Redemptions before tax).</li><li>Kilo Menu order: Redemption discount 8% of gross order value.</li><li>Kilo Menu Take away: Additional redemption discount "+this.takeawayDiscount+" of gross order value.</li><li>Kilo Menu purchase: Kilo point accumulation 15% of gross order value.</li><li>Kilo Party order: Redemption discount 5% of gross order value.</li><li>Kilo Party Take away: Additional redemption discount "+this.takeawayDiscount+" of gross order value.</li><li>Kilo Party purchase: Kilo point accumulation 10 % of gross order value.</li><li>Kilo Store: No Redemption discount.</li><li>Kilo Store purchase: Kilo point accumulation 5% of gross order value.</li><li>The policy of awarding fresh Kilo points and its subsequent utilisation towards discount, is subject to change without prior notice at the sole discretion of Kilosubzi.com.</li></ul><br>");
	 }

	payTmErrorAlert=function(error) {
	let alert = this.alerCtrl.create({
		// title: 'New Friend!',
		subTitle: error,
		buttons: ['OK']
	});
	alert.present();
}

kilomenu(cartid)
	{
		window.localStorage.setItem('localid', cartid );
		//window.localStorage.setItem('subcatid', subcat );
		//var xyz = window.localStorage.getItem('localid');
		
		//alert(cartid)
		if(cartid==1)
		{
			//this.navCtrl.push(KiloMenuPage);
			this.navCtrl.setRoot(KiloMenuPage);
		}
		if(cartid==2)
		{
			//this.navCtrl.push(KiloPartyPage);
			this.navCtrl.setRoot(KiloPartyPage);
		}
		if(cartid==3)
		{
			//this.navCtrl.push(KiloStorePage);
			this.navCtrl.setRoot(KiloStorePage);
		}
		
	}
	
}






// WEBPACK FOOTER //
// ./src/pages/kilopoints/kilopoints.ts